const countryCodeEnum = Object.freeze({
  SINGAPORE: 'sg',
  HONGKONG: 'hk',
});

export default countryCodeEnum;
